var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-2 mt-2 logo"},[_c('img',{attrs:{"width":"42","height":"42","src":"/img/icons/apple-touch-icon-60x60.png"}})])}]

export { render, staticRenderFns }